module.exports = __webpack_public_path__ + "static/media/share.05877adc.svg";